import React, { Component } from 'react'

export default class SplashView extends Component {
  render() {
    const {props} = this

    return (
      <div className="Splash">
        <div className="logo Bubble-Time">LA Game Night</div>


        <form action="https://gamejamla.us18.list-manage.com/subscribe/post" method="POST" onSubmit={props.submit}>
          <input type="hidden" name="u" value="d86c051b4d65aa09e9fa6b8ba" />
          <input type="hidden" name="id" value="3b1d1c9817" />

          <div className="unfillable" aria-label="Please leave the following three fields empty">
              <label htmlFor="b_name">Name: </label>
              <input type="text" name="b_name" tabIndex="-1" value="" placeholder="Freddie" id="b_name" />

              <label htmlFor="b_email">Email: </label>
              <input type="email" name="b_email" tabIndex="-1" value="" placeholder="youremail@gmail.com" autoComplete="false" id="b_email" />

              <label htmlFor="b_comment">Comment: </label>
              <textarea name="b_comment" tabIndex="-1" placeholder="Please comment" id="b_comment"></textarea>
          </div>

          <label>
            Email Address
            <input type="email" name="email" autoComplete="email" placeholder="you@gmail.com"
                   autoFocus={true} onChange={props.changeText} autoCapitalize="false" autoCorrect="false"
                   className={props.error && 'error'}/>
          </label>

          { props.success ?
            <div className="success">
              {`You're In!`}
            </div>
          :
            <button>
              Subscribe
            </button>
          }
        </form>

        { !props.error ? null :
          <div className="error">
            {props.error}
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SplashView.js